import { environment } from './../../../environments/environment';
import { IUser } from './../models/user.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthService {

    private _url = `${environment.backendRoot}/webresources/frontend/entity.users/login`;
    private _registrationUrl = `${environment.backendRoot}/webresources/frontend/entity.users/register`;
    private userUrl = `${environment.backendRoot}/webresources/frontend/entity.users/profile/`;
    private socialUrl = `${environment.backendRoot}/webresources/frontend/entity.users/`;
    private setNewPasswordUrl = `${environment.backendRoot}/webresources/frontend/entity.users/setPassword`;


  user = {
        email: null,
        passwd: null
    };

    constructor(private http: HttpClient) { }

    login(email: string, password: string): Observable<any> {
        this.user = {email: email, passwd: password};
        return this.http.post(this._url, this.user,
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
            }
        );
    }

    forgotPassword(email: string, password: string): Observable<any> {
      this.user = {email: email, passwd: password};
      return this.http.post(this.setNewPasswordUrl, this.user,
        {
          headers: new HttpHeaders()
            .set('Content-Type', 'application/json')
        }
      );
    }

    register(user) {
        const data =  JSON.stringify(user);
        return this.http.put(this._registrationUrl, data,
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
            }
        );
    }

    getUserById(userId: number): Observable<any> {
        const url = this.userUrl + userId;
        return this.http.get(url,
            { headers: new HttpHeaders().set('Content-Type', 'application/json') }
        );
    }

    socialLogin(social, path) {
        const url = this.socialUrl + social + '?redirecturi=' + encodeURIComponent(path);
        console.log(url);

        return this.http.get(url,
            { headers: new HttpHeaders().set('Content-Type', 'text/plain') }
        );
    }

}
